<!-- 项目子项 -->
<template lang="pug">
form-item-wrapper(v-bind="bind", :rules="rules", :class="formItemClass")
  el-select.width-full(v-if="isEdit", :value="fieldModelValue", :multiple="multiple", filterable, clearable, @change="setModel")
    el-option(v-for="item in optionList", :key="item.value", :label="item.label", :value="item.value")
  el-input.readonly-mode(v-else v-model="fieldModelName" disabled)
</template>

<script>
import { staticMixins, mapVFAssignField } from "@/CommonDP/VForm/utils";
import flowService from "@/CommonDP/service/flow-service";

// 分割符
const separator = ",";

export default {
  components: {},
  mixins: [staticMixins],
  data() {
    return {
      optionList: []
    };
  },
  computed: {
    ...mapVFAssignField("childNameKey"), // 关联其他组件
    // 默认值
    vmDefaultValue() {
      return "";
    },
    // 是否多选
    multiple() {
      return this.options?.multiple2;
    },
    // 绑定值
    fieldModelValue() {
      const { fieldModel, multiple } = this;
      if (multiple) {
        return fieldModel ? fieldModel.split(separator) : [];
      } else {
        return fieldModel;
      }
    },
    // 展示值
    fieldModelName() {
      const { fieldModel, multiple } = this;
      if (multiple) {
        const options = this.optionList.filter((e) => this.fieldModelValue.includes(e.value));
        return options.map((it) => it.label)?.join(separator) || "";
      } else {
        return this.optionList.find((e) => e.value === fieldModel)?.label || "";
      }
    }
  },
  created() {
    this.initList();
  },
  methods: {
    // 初始化数据
    async initList() {
      const { data } = await flowService.getPrjChildListByPrjId(this.prjId);
      this.optionList =
        data?.map((it) => ({
          value: it.childId,
          label: it.childName
        })) || [];
    },

    // 设置选中值
    setModel(val) {
      const { multiple } = this;
      this.fieldModel = multiple ? (val || []).join(separator) : val;
      this.emitValidate(); // 发送验证
    },
    // 关联其他组件
    withUpdate() {
      this.childNameKey = this.fieldModelName;
    }
  }
};
</script>

<style lang="scss" scoped>
.width-full {
  display: block;
}
.readonly-mode {
  width: 100%;
  display: inline-block;
  white-space: pre-wrap;
  line-height: 1.5;
  color: #c0c4cc;
}
</style>
